<template>
  <!-- <transition name="libraryInput-fade" mode="out-in"> -->
    <div v-if="isView" class="libraryInput">
      <div>
        <div class="title">
          <span>{{ title }}</span>
          <span v-if="type === 'default'" class="right">공백포함 {{ textSize }} / {{ total }}</span>
        </div>
        <div v-if="type === 'default'">
          <UInput :type="multiline ? 'textarea' : 'text'" :limitHeight="150" placeholder="" v-model="data" :auto="true" :limit="total" @enter="inputSubmit" @esc="cancel"/>
        </div>
        <div v-else-if="type === 'genre'">
          <TabBar class="genreBar" display="tabButton" :list="genreList" v-model="genreinit" @selected="genreSelect"/>
          <Uselectbox class="genreSelect" description="선택" :options="genreSubList" @selected="selectGenre" v-model="genreSubIndex" display="up" :stepH="36"/>
        </div>
        <div v-else-if="type === 'adult'">
          <TabBar class="adult" display="tabButton" direction="column" :list="adultList" v-model="adultinit" @selected="adultSelect"/>
        </div>
        <div v-if="description !== undefined" class="description">
          {{ description }}
        </div>
        <div class="button">
          <UbuttonList size="small" align="center" :data="buttonList"/>
        </div>
      </div>
    </div>
  <!-- </transition> -->
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import TabBar from '@/components/layout/TabBar.vue'
import {Genre, State} from '@/components/js/Utils'

export default {
  props: {
  },
  created () {
  },
  mounted () {
    console.log(this.$route.name)
    this.$center.addEvent('libraryInput-open', this.open)
  },
  beforeDestroy () {
    this.$center.removeEvent('libraryInput-open', this.open)
  },
  data () {
    return {
      type: '',
      multiline: false,
      title: '',
      isView: false,
      data: '',
      count: 30,
      description: '',
      option: null,
      genreList: [
        {name: Genre.toString(Genre.NOVEL), index: 0, tab: Genre.NOVEL},
        {name: Genre.toString(Genre.LIFE), index: 1, tab: Genre.LIFE},
        {name: Genre.toString(Genre.ROMANCE), index: 2, tab: Genre.ROMANCE},
        {name: Genre.toString(Genre.FANTASY), index: 3, tab: Genre.FANTASY},
        {name: Genre.toString(Genre.BOYLOVE), index: 4, tab: Genre.BOYLOVE}
      ],
      genre: null,
      genreinit: -1,
      genreSubIndex: -1,
      adultList: [
        {name: '이 책의 연령 등급은 전체 이용가 입니다.', index: 0, tab: 0},
        {name: '이 책의 연령 등급은 성인물 입니다.', index: 1, tab: State.ADULT, style: {'background-color': 'var(--require)', 'border': '1px solid var(--require)'}}
      ],
      adultinit: -1
    }
  },
  name: 'LibraryInput',
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: this.cancel},
        {name: '확인', state: this.state, click: this.submit}
      ]
    },
    textSize () {
      return this.data.length
    },
    total () {
      return (this.count === undefined) ? 30 : this.count
    },
    state () {
      switch (this.type) {
        case 'genre' :
        case 'adult' :
          return 'active'
        default :
          if (this.data !== '') {
            return 'active'
          } else {
            return 'disable'
          }
      }
    },
    genreSubList () {
      console.log(this.genreinit)
      if (this.genreinit === -1) {
        return []
      } else {
        var subgenrecount = [6, 4, 4, 10, 3]
        var temp = []
        var i
        for (i = 0; i < subgenrecount[this.genreinit]; i++) {
          temp.push({
            text: Genre.subgenreString(this.genreList[this.genreinit].tab, i + 1),
            id: i,
            value: i + 1
          })
        }
        return temp
      }
    }
  },
  methods: {
    open (e) {
      console.log('open', e)
      this.type = (e.type) ? e.type : 'default'
      this.title = e.title
      this.multiline = (e.multiline) ? e.multiline : false
      this.count = e.count
      this.description = e.description
      this.option = e
      switch (e.type) {
        case 'genre' :
          this.genre = e.value
          for (var i = 0; i < this.genreList.length; i++) {
            if (this.genreList[i].tab === e.value.genre) {
              this.genre.index = this.genreList[i].index
              this.genreinit = this.genreList[i].index
            }
          }
          this.genreSubIndex = e.value.subgenre - 1
          break
        case 'adult' :
          console.log(e.value & State.ADULT)
          if (e.value & State.ADULT) {
            this.adultinit = 1
          } else {
            this.adultinit = 0
          }
          break
        default :
          this.data = (e.value) ? e.value : ''
          break
      }
      this.isView = true
      this.$store.commit('inputLibrary', true)
      this.$emit('show', true)
      this.$root.$el.addEventListener('mouseup', this.mouseUp)
      setTimeout(() => {
        if (this.type === 'default') {
          if (this.multiline) {
            document.querySelector('.libraryInput textarea').focus()
          } else {
            document.querySelector('.libraryInput input').focus()
          }
        }
      })
    },
    cancel () {
      this.complete({success: false})
    },
    inputSubmit () {
      if (!this.multiline) {
        this.submit()
      }
    },
    submit () {
      switch (this.type) {
        case 'genre' :
          this.genre = null
          this.complete({success: true, value: {genre: this.genreList[this.genreinit].tab, subgenre: this.genreSubIndex + 1}})
          break
        case 'adult' :
          this.complete({success: true, value: this.adultinit === 1})
          break
        default :
          this.complete({success: true, value: this.data})
          break
      }
    },
    complete (data) {
      this.$center.dispatch('libraryInput-complete', data)
      this.isView = false
      this.$store.commit('inputLibrary', false)
      this.$emit('show', false)
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
    },
    mouseUp (e) {
      if (!this.isTarget(e, this.$el)) {
        this.complete({success: false})
        this.$root.$el.removeEventListener('mouseup', this.mouseUp)
      }
    },
    genreSelect (e) {
      console.log(e)
      if (e.current === this.genre.index) {
        this.genreSubIndex = this.genre.subgenre - 1
      } else {
        this.genreSubIndex = -1
      }
    },
    selectGenre (e) {
      console.log(e)
      this.genreSubIndex = e.current
    },
    adultSelect (e) {

    }
  },
  components: {
    UInput,
    TabBar
  }
}
</script>

<style scoped>
.libraryInput {
  /* height: 200px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-top: auto; */
  border-top: 1px solid var(--line-guide);
  background-color: var(--bg-white);
  padding: 20px;
  color: var(--text-base);
  z-index: 5;
}
.libraryInput > div {
  width: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.libraryInput .title {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  border-bottom: 1px solid var(--line-title);
  height: 30px;
}
.libraryInput .title span:first-child {
  font-size: 18px;
  color: var(--text-title);
}
.libraryInput .title .right {
  color: var(--text-base);
}
.libraryInput .input {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0px 10px;
  border: 1px solid var(--line-guide);
  min-height: 30px;
}
.libraryInput .button {
  display: flex;
  margin-top: auto;
}
.libraryInput .description {
  text-align: left;
  margin-bottom: 20px;
}
.libraryInput-fade-enter-active {
  transition: all .2s ease;
}
.libraryInput-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.libraryInput-fade-enter, .footnote-fade-leave-to {
  transform: translateY(300px);
}
.genreBar {
  height: 36px;
  margin: 10px 0px;
}
.genreSelect {
  height: 36px;
  margin-bottom: 20px;
}
.adult {
  line-height: 36px;
  margin: 10px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/library/LibraryInput.vue